"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chevron = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var Chevron_style_1 = __importDefault(require("./Chevron.style"));
/**
 * Chevron atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-icons-chevron--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Chevron Source}
 */
var Chevron = function (_a) {
    var _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b, _c = _a.color, color = _c === void 0 ? 'inherit' : _c, className = _a.className, hoverVariant = _a.hoverVariant, _d = _a.width, width = _d === void 0 ? 12 : _d, _e = _a.height, height = _e === void 0 ? 8 : _e, svgIconProps = __rest(_a, ["isExpanded", "color", "className", "hoverVariant", "width", "height"]);
    var classes = (0, Chevron_style_1.default)();
    var styles = { width: width, height: height };
    return ((0, jsx_runtime_1.jsx)(core_1.SvgIcon, __assign({ viewBox: '6 8 12 8', style: styles, htmlColor: color, className: (0, classnames_1.default)(className, isExpanded ? classes.expanded : classes.collapsed, hoverVariant === 'default' && classes.hoverDefault) }, svgIconProps, { children: (0, jsx_runtime_1.jsx)("path", { d: icons_1.default.chevronDown.path }) })));
};
exports.Chevron = Chevron;
